import { SunWirelessOutlineIcon } from './SunWirelessOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2CFA10C3-9284-4120-B104-D196DBF0BF07
 * name sun-wireless-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-wireless-outline.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const UvRayOutlineIcon = SunWirelessOutlineIcon;
export default UvRayOutlineIcon